import { render, staticRenderFns } from "./topView.vue?vue&type=template&id=c4b5f944&scoped=true"
import script from "./topView.vue?vue&type=script&lang=js"
export * from "./topView.vue?vue&type=script&lang=js"
import style0 from "./topView.vue?vue&type=style&index=0&id=c4b5f944&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b5f944",
  null
  
)

export default component.exports